import {Box, Grid} from '@mui/material';

import {InterestCard} from '../IntererestCard/InterestCard';
import {MatchCard} from '../MatchCard/MatchCard';

import {Match} from '../../../dashboard/types/ApplicantMatchesTypes';

interface Props {
  match: Match;
  onClick: (isInterested?: boolean) => void;
}

export const MatchDetailsHeader = ({match, onClick}: Props) => {
  return (
    <Grid
      data-testid='match-details-header'
      container
      spacing='32px'
      paddingBottom='66px'
      alignItems='stretch'
      sx={{flex: '1', display: 'flex'}}
    >
      <Grid item md={6} sm={8} width='100%'>
        <Box width='100%'>
          <MatchCard
            match={match}
            bgColor={'white'}
            sx={{borderRadius: '16px'}}
            isButton={false}
          />
        </Box>
      </Grid>
      <Grid item md={6} xs={12} width='100%'>
        <Box sx={{width: '100%', height: '100%'}}>
          <InterestCard onClick={onClick} status={match.status} />
        </Box>
      </Grid>
    </Grid>
  );
};
